<template>
  <div>
    <div v-if="!horse">Missing horse id</div>
    <span v-else-if="noLink" :class="classList">
      {{ displayName }}
    </span>
    <router-link
      v-else
      :to="{ name: 'HorseProfilePage', params: { horseId: horse.id } }"
      :class="[classList, 'no-default-link-style']"
      :target="linkTarget"
    >
      {{ displayName }}
    </router-link>
    <slot name="horseNameAdditionalDetails" :horse="horse" />
    <div>
      <slot name="appendHorseDetails" :horse="horse" />
    </div>
  </div>
</template>
<script>
import gql from "fraql";

export default {
  name: "AppShowHorseName",
  props: {
    horse: {
      type: Object,
      default: null
    },
    showIdentifier: {
      type: Boolean,
      default: false
    },
    noLink: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: ""
    },
    linkTarget: {
      type: String,
      default: undefined
    }
  },
  computed: {
    displayHorse() {
      if (typeof this.horse === "string" || this.horse instanceof String) {
        return this.queriedHorse || { id: this.horse };
      } else {
        return this.horse;
      }
    },
    displayName() {
      let nameDetails = this.displayHorse.name;
      const identifiers = [
        this.displayHorse.feiid,
        this.displayHorse.identifier
      ].filter(Boolean);
      if (this.showIdentifier && identifiers.length) {
        nameDetails += ` (${identifiers.join(", ")})`;
      }
      /*if (this.displayHorse.feiid) {
        nameDetails += ` | ${this.displayHorse.feiid}`;
      }*/
      return nameDetails;
    }
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        id
        name
        feiid
        identifier
      }
    `
  },
  apollo: {
    queriedHorse: {
      query: gql`
        query showHorseName($id: ID) {
          horse(id: $id) {
            id
            name
            feiid
            identifier
          }
        }
      `,
      variables() {
        return {
          id: this.horse
        };
      },
      skip() {
        return !(
          typeof this.horse === "string" || this.horse instanceof String
        );
      },
      update(data) {
        return data.horse;
      }
    }
  }
};
</script>
